import React, { useState, useRef, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import redirectURL from "../redirectURL";

const ZONES = ["North", "South", "East", "West", "Central", "North East"];

export default function SeasonalBufferMaster() {
    const gridRef = useRef();

    const decipher = (salt) => {
        const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
        const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);
        return (encoded) =>
            (encoded || "")
                .match(/.{1,2}/g)
                ?.map((hex) => parseInt(hex, 16))
                .map(applySaltToChar)
                .map((charCode) => String.fromCharCode(charCode))
                .join("") || "";
    };
    const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");

    const [sources, setSources] = useState([]);
    const [transporters, setTransporters] = useState([]);
    const [entities, setEntities] = useState([]);

    const [sourceFilter, setSourceFilter] = useState("");
    const [transporterFilter, setTransporterFilter] = useState("");
    const [entityFilter, setEntityFilter] = useState("");

    const [rowData, setRowData] = useState([]);

    const [show, setShow] = useState(false);
    const [basicType, setBasicType] = useState("");
    const [basicTitle, setBasicTitle] = useState("");

    const [showModal, setShowModal] = useState(false);
    const [modalMode, setModalMode] = useState("add");
    const [editingIndex, setEditingIndex] = useState(null);
    const [showloader, setshowloader] = useState("show-n");
    const [resetKey, setResetKey] = useState(0);

    const emptyForm = {
        invoice_source: "",
        transporter_name: "",
        entity: "",
        dispatch_from: "",
        dispatch_to: "",
        destination_zone: [],
        buffer_days: ""
    };

    const [modalForm, setModalForm] = useState(emptyForm);
    const [modalErrors, setModalErrors] = useState({});

    useEffect(() => {
        loadDropdowns();
        loadData();
    }, []);

    const clearFieldError = (field) => {
        setModalErrors((prev) => ({ ...prev, [field]: "" }));
    };

    const loadDropdowns = async () => {
        setshowloader("show-m");
        try {
            const tr = await redirectURL.post("/consignments/getTransportersList", {});
            const tRecords = tr?.data?.tptMaster || [];
            setTransporters(
                [...new Set(tRecords.map((x) => x.transporter_name))]
                    .filter(Boolean)
                    .sort()
                    .map((x) => ({ label: x, value: x }))
            );

            const src = await redirectURL.post("/consignments/getSourceTypes", {});
            const sRecords = src?.data?.sourceMaster || [];
            setSources(
                [...new Set(sRecords.map((x) => x.invoice_source))]
                    .filter(Boolean)
                    .sort()
                    .map((x) => ({ label: x, value: x }))
            );

            const ent = await redirectURL.post("/consignments/allEntityData", {});
            const eRecords = ent?.data || [];
            setEntities(
                [...new Set(eRecords.map((x) => x.entity))]
                    .filter(Boolean)
                    .sort()
                    .map((x) => ({ label: x, value: x }))
            );
        } catch (err) {
            console.error("Dropdown Load Error", err);
        }
        setshowloader("show-n");
    };

    const loadData = async () => {
        setshowloader("show-m");
        const req = {
            invoice_source: sourceFilter || null,
            transporter_name: transporterFilter || null,
            entity: entityFilter || null
        };

        try {
            const resp = await redirectURL.post("/consignments/getSeasonalBuffer", req);

            if (resp?.data?.status === "success") {
                setRowData(
                    (resp.data.records || []).map((r) => ({
                        ...r,
                        _id: r._id?.toString() || null,
                        destination_zone: Array.isArray(r.destination_zone)
                            ? r.destination_zone
                            : r.destination_zone
                                ? [r.destination_zone]
                                : [],
                        isDirty: false
                    }))
                );
            } else {
                setRowData([]);
            }
        } catch (err) {
            console.error("Load data error", err);
            setRowData([]);
        }
        setshowloader("show-n");
    };
    useEffect(() => {
        if (sourceFilter === "" && transporterFilter === "" && entityFilter === "") {
            loadData();
        }
    }, [sourceFilter, transporterFilter, entityFilter, resetKey]);


    const resetFilters = () => {
        setSourceFilter("");
        setTransporterFilter("");
        setEntityFilter("");
        setRowData([]);
        setResetKey(prev => prev + 1);
    };

    const isDuplicateEntities = (src, tpt, entityString, ignoreIndex = null) => {
        if (!entityString) return false;

        const selectedEntities = Array.isArray(entityString)
            ? entityString
            : entityString.split(",").map(e => e.trim());


        const matchedRows = rowData.filter((row, idx) =>
            idx !== ignoreIndex &&
            row.invoice_source === src &&
            row.transporter_name === tpt
        );
        const existing = new Set();
        matchedRows.forEach(r => {
            if (Array.isArray(r.entity)) {
                r.entity.forEach(ent => existing.add(ent.trim()));
            } else if (typeof r.entity === "string") {
                r.entity.split(",").forEach(ent => existing.add(ent.trim()));
            }
        });
        return selectedEntities.some(ent => existing.has(ent));
    };

    const isDuplicateRow = (row, idx) => {
        return rowData.filter(
            (r, i) =>
                i !== idx &&
                r.invoice_source === row.invoice_source &&
                r.transporter_name === row.transporter_name &&
                r.entity === row.entity
        ).length > 0;
    };

    const columnDefs = [
        {
            headerName: "",
            width: 100,
            cellRenderer: (params) => {
                return (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            width: "100%"
                        }}
                    >
                        <button
                            className="btn btn-primary"
                            style={{
                                width: "70px",
                                height: "30px",
                                fontSize: "13px",
                                padding: "0px",
                                marginRight: "6px"
                            }}
                            onClick={() => openEditModal(params)}
                        >
                            Edit
                        </button>
                    </div>
                );
            }
        },
        { headerName: "Source", field: "invoice_source", width: 150 },
        { headerName: "Transporter", field: "transporter_name", width: 170 },
        { headerName: "Entity", field: "entity", width: 140 },
        { headerName: "Dispatch From", field: "dispatch_from", width: 150 },
        { headerName: "Dispatch To", field: "dispatch_to", width: 130 },
        {
            headerName: "Destination Zone",
            field: "destination_zone",
            width: 200,
            valueGetter: (p) =>
                p.data.destination_zone?.length === 1 &&
                    p.data.destination_zone[0] === "All"
                    ? "All"
                    : (p.data.destination_zone || []).join(", ")
        },
        { headerName: "Buffer Days", field: "buffer_days", width: 120 }
    ];

    const defaultColDef = {
        resizable: true,
        sortable: true,
        filter: true
    };

    const openAddModal = () => {
        setModalMode("add");
        setEditingIndex(null);
        setModalForm(emptyForm);
        setModalErrors({});
        setShowModal(true);
    };

    const openEditModal = (params) => {
        const d = params.data;
        setModalMode("edit");
        setEditingIndex(params.rowIndex);
        setModalForm({
            invoice_source: d.invoice_source || "",
            transporter_name: d.transporter_name || "",
            entity: Array.isArray(d.entity)
                ? d.entity
                : d.entity
                    ? d.entity.split(",")
                    : [],
            dispatch_from: d.dispatch_from || "",
            dispatch_to: d.dispatch_to || "",
            destination_zone:
                Array.isArray(d.destination_zone) && d.destination_zone.length
                    ? d.destination_zone
                    : [],
            buffer_days: d.buffer_days ? String(d.buffer_days) : ""
        });
        setModalErrors({});
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setModalErrors({});
    };

    const zoneOptions = [
        { label: "All", value: "All" },
        ...ZONES.map((z) => ({ label: z, value: z }))
    ];

    const getZoneSelectValue = () => {
        const dz = modalForm.destination_zone || [];
        if (dz.length === 1 && dz[0] === "All") {
            return [{ label: "All", value: "All" }];
        }
        return ZONES.filter((z) => dz.includes(z)).map((z) => ({
            label: z,
            value: z
        }));
    };

    const handleZoneChange = (selected) => {
        const values = (selected || []).map((o) => o.value);
        if (values.includes("All")) {
            setModalForm((prev) => ({ ...prev, destination_zone: ["All"] }));
        } else {
            setModalForm((prev) => ({ ...prev, destination_zone: values }));
        }
        clearFieldError("destination_zone");
    };

    const validateModalForm = () => {
        const f = modalForm;
        let errors = {};

        if (!f.invoice_source) errors.invoice_source = "Source is required";
        if (!f.transporter_name) errors.transporter_name = "Transporter is required";
        if (!f.entity) errors.entity = "Entity is required";

        if (!f.dispatch_from) errors.dispatch_from = "Dispatch From is required";
        if (!f.dispatch_to) errors.dispatch_to = "Dispatch To is required";

        if (f.dispatch_from && f.dispatch_to) {
            if (new Date(f.dispatch_from) > new Date(f.dispatch_to)) {
                errors.dispatch_to = "Dispatch To must be after Dispatch From";
            }
        }

        if (!f.destination_zone?.length) {
            errors.destination_zone = "Select at least one Destination Zone";
        }

        if (!f.buffer_days) errors.buffer_days = "Buffer Days is required";
        else if (!/^\d{1,3}$/.test(f.buffer_days))
            errors.buffer_days = "Buffer Days must be numeric";

        setModalErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const resetSeasonalModalForm = () => {
        setModalForm({
            invoice_source: "",
            transporter_name: "",
            entity: [],
            dispatch_from: "",
            dispatch_to: "",
            destination_zone: [],
            buffer_days: ""
        });

        setModalErrors({});
    };

    const handleModalSave = async () => {
        if (!validateModalForm()) return;

        const f = modalForm;
        if (
            isDuplicateEntities(
                f.invoice_source,
                f.transporter_name,
                f.entity,
                modalMode === "edit" ? editingIndex : null
            )
        ) {
            setModalErrors(prev => ({
                ...prev,
                entity: "One or more selected entities already exist for this Source + Transporter"
            }));
            return;
        }
        const payload = {
            record: {
                ...f,
                buffer_days: Number(f.buffer_days)
            },
            unique_id: modalMode === "edit" ? rowData[editingIndex]._id : null,
            email: decode(localStorage.getItem("email")) || "system"
        };
        try {
            setshowloader("show-m");

            const resp = await redirectURL.post(
                "/consignments/saveSeasonalBuffer",
                payload
            );

            setshowloader("show-n");

            if (resp?.data?.status === "success") {
                setBasicType("success");
                setBasicTitle("Saved Successfully!");
                setShow(true);
                setShowModal(false);
                loadData();
            } else {
                setModalErrors(prev => ({
                    ...prev,
                    saveError: resp?.data?.message || "Save failed"
                }));
            }
        } catch (err) {
            setshowloader("show-n");
            setModalErrors(prev => ({
                ...prev,
                saveError: "Server error while saving"
            }));
        }
    };

    return (
        <div className="container-fluid">
            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={() => setShow(false)}
            />

            <div className="card">
                <div className="card-body">
                    <div className="row align-items-end">
                        <div className="col-xl-2 col-lg-3">
                            <label>Source</label>
                            <Select
                                options={sources}
                                value={sources.find((x) => x.value === sourceFilter) || null}
                                onChange={(e) => setSourceFilter(e ? e.value : "")}
                            />
                        </div>

                        <div className="col-xl-2 col-lg-3">
                            <label>Transporter</label>
                            <Select
                                options={transporters}
                                value={
                                    transporters.find((x) => x.value === transporterFilter) ||
                                    null
                                }
                                onChange={(e) => setTransporterFilter(e ? e.value : "")}
                            />
                        </div>

                        <div className="col-xl-2 col-lg-3">
                            <label>Entity</label>
                            <Select
                                options={entities}
                                value={entities.find((x) => x.value === entityFilter) || null}
                                onChange={(e) => setEntityFilter(e ? e.value : "")}
                            />
                        </div>

                        <div
                            className="col-xl-3 col-lg-3"
                            style={{ paddingTop: "28px", marginBottom: 3 }}
                        >
                            <button className="btn btn-success" onClick={loadData}>
                                Get Data
                            </button>
                            &nbsp;
                            <button className="btn btn-default" onClick={resetFilters}>
                                Reset
                            </button>
                        </div>

                        <div className="col-xl-3 d-flex justify-content-end" style={{ paddingTop: "28px" }}>
                            <button className="btn btn-primary" onClick={openAddModal}>
                                + Add Row
                            </button>
                        </div>
                    </div>

                    <div
                        className="ag-theme-balham mt-3"
                        style={{ height: "480px", width: "100%" }}
                    >
                        <AgGridReact
                            ref={gridRef}
                            rowData={rowData}
                            columnDefs={columnDefs}
                            defaultColDef={{
                                ...defaultColDef,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                cellStyle: {
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "14px"
                                }
                            }}
                            rowHeight={32}
                            pagination={true}
                            paginationPageSize={20}
                            sideBar={{
                                toolPanels: [
                                    {
                                        id: "columns",
                                        labelDefault: "Columns",
                                        iconKey: "columns",
                                        toolPanel: "agColumnsToolPanel"
                                    },
                                    {
                                        id: "filters",
                                        labelDefault: "Filters",
                                        iconKey: "filter",
                                        toolPanel: "agFiltersToolPanel"
                                    }
                                ],
                                position: "right",
                                defaultToolPanel: ""
                            }}
                            getRowStyle={(params) =>
                                isDuplicateRow(params.data, params.rowIndex)
                                    ? { backgroundColor: "#ffcccc" }
                                    : null
                            }
                        />
                    </div>
                </div>
            </div>

            {showModal && (
                <>
                    <div className="modalOverlay" onClick={closeModal}></div>

                    <div
                        className="rightModal"
                        style={{
                            position: "fixed",
                            top: 0,
                            right: 0,
                            width: "420px",
                            height: "100vh",
                            background: "#fff",
                            zIndex: 9999,
                            overflowY: "auto",
                            padding: "20px",
                            boxShadow: "-3px 0 10px rgba(0,0,0,0.2)"
                        }}
                    >
                        <button
                            className="close"
                            onClick={closeModal}
                            style={{
                                position: "absolute",
                                top: "15px",
                                right: "15px",
                                fontSize: "26px",
                                fontWeight: "700",
                                border: "none",
                                background: "transparent",
                                cursor: "pointer"
                            }}
                        >
                            ×
                        </button>

                        <div
                            style={{
                                backgroundColor: "#1F6F8B",
                                color: "white",
                                padding: "12px 0",
                                textAlign: "center",
                                fontSize: "18px",
                                fontWeight: "600",
                                position: "relative",
                                margin: "-20px -20px 20px -20px"
                            }}
                        >
                            {modalMode === "add" ? "Add Seasonal Buffer" : "Edit Seasonal Buffer"}

                            <button
                                onClick={closeModal}
                                style={{
                                    position: "absolute",
                                    right: "15px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "50%",
                                    border: "none",
                                    backgroundColor: "#0B3C5D",
                                    color: "white",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    cursor: "pointer",
                                    padding: 0,
                                    lineHeight: "32px",
                                    textAlign: "center"
                                }}
                            >
                                X
                            </button>
                        </div>

                        <label>Source <span style={{ color: 'red' }}>*</span></label>
                        <Select
                            className="mb-1"
                            options={sources}
                            value={
                                modalForm.invoice_source
                                    ? { label: modalForm.invoice_source, value: modalForm.invoice_source }
                                    : null
                            }
                            onChange={(e) => {
                                setModalForm(prev => ({ ...prev, invoice_source: e ? e.value : "" }));
                                clearFieldError("invoice_source");
                            }}
                        />
                        {modalErrors.invoice_source && (
                            <div style={{ color: "red", marginBottom: 10 }}>
                                {modalErrors.invoice_source}
                            </div>
                        )}

                        <label>Transporter <span style={{ color: 'red' }}>*</span></label>
                        <Select
                            className="mb-1"
                            options={transporters}
                            value={
                                modalForm.transporter_name
                                    ? { label: modalForm.transporter_name, value: modalForm.transporter_name }
                                    : null
                            }
                            onChange={(e) => {
                                setModalForm(prev => ({ ...prev, transporter_name: e ? e.value : "" }));
                                clearFieldError("transporter_name");
                            }}
                        />
                        {modalErrors.transporter_name && (
                            <div style={{ color: "red", marginBottom: 10 }}>
                                {modalErrors.transporter_name}
                            </div>
                        )}

                        <label>Entity <span style={{ color: 'red' }}>*</span></label>
                        <Select
                            isMulti
                            className="mb-1"
                            options={entities}
                            value={
                                Array.isArray(modalForm.entity)
                                    ? modalForm.entity.map(e => ({ label: e, value: e }))
                                    : []
                            }
                            onChange={(selected) => {
                                const values = selected ? selected.map(s => s.value) : [];
                                setModalForm(prev => ({
                                    ...prev,
                                    entity: values
                                }));
                                clearFieldError("entity");
                            }}
                        />
                        {modalErrors.entity && (
                            <div style={{ color: "red", marginBottom: 10 }}>
                                {modalErrors.entity}
                            </div>
                        )}
                        <label>Dispatch From <span style={{ color: 'red' }}>*</span></label>
                        <input
                            type="date"
                            className="form-control mb-1"
                            value={modalForm.dispatch_from}
                            onChange={(e) => {
                                setModalForm(prev => ({ ...prev, dispatch_from: e.target.value }));
                                clearFieldError("dispatch_from");
                            }}
                        />
                        {modalErrors.dispatch_from && (
                            <div style={{ color: "red", marginBottom: 10 }}>
                                {modalErrors.dispatch_from}
                            </div>
                        )}

                        <label>Dispatch To <span style={{ color: 'red' }}>*</span></label>
                        <input
                            type="date"
                            className="form-control mb-1"
                            value={modalForm.dispatch_to}
                            onChange={(e) => {
                                setModalForm(prev => ({ ...prev, dispatch_to: e.target.value }));
                                clearFieldError("dispatch_to");
                            }}
                        />
                        {modalErrors.dispatch_to && (
                            <div style={{ color: "red", marginBottom: 10 }}>
                                {modalErrors.dispatch_to}
                            </div>
                        )}
                        <label>Destination Zone <span style={{ color: 'red' }}>*</span></label>
                        <Select
                            isMulti
                            className="mb-1"
                            options={zoneOptions}
                            value={getZoneSelectValue()}
                            onChange={(selected) => {
                                handleZoneChange(selected);
                                clearFieldError("destination_zone");
                            }}
                        />
                        {modalErrors.destination_zone && (
                            <div style={{ color: "red", marginBottom: 10 }}>
                                {modalErrors.destination_zone}
                            </div>
                        )}

                        <label>Buffer Days <span style={{ color: 'red' }}>*</span></label>
                        <input
                            type="text"
                            className="form-control mb-1"
                            value={modalForm.buffer_days}
                            onChange={(e) => {
                                const v = e.target.value.replace(/\D/g, "");
                                if (v.length <= 3) {
                                    setModalForm(prev => ({ ...prev, buffer_days: v }));
                                }
                                clearFieldError("buffer_days");
                            }}
                        />
                        {modalErrors.buffer_days && (
                            <div style={{ color: "red", marginBottom: 10 }}>
                                {modalErrors.buffer_days}
                            </div>
                        )}

                        {modalErrors.saveError && (
                            <div style={{ color: "red", marginBottom: 10, fontWeight: 600 }}>
                                {modalErrors.saveError}
                            </div>
                        )}

                        <div
                            className="mt-3"
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center"
                            }}
                        >
                            <button
                                className="btn"
                                style={{
                                    width: "100px",
                                    height: "40px",
                                    fontSize: "15px",
                                    marginRight: "4px",
                                    backgroundColor: "#a6a7a8ff", borderColor: "#a6a7a8ff",
                                    borderRadius: "5px"
                                }}
                                onClick={resetSeasonalModalForm}
                            >
                                Reset
                            </button>
                            <button
                                className="btn btn-secondary"
                                style={{ width: "120px", height: "40px", marginRight: "8px" }}
                                onClick={closeModal}
                            >
                                Cancel
                            </button>

                            <button
                                className="btn btn-success"
                                style={{ width: "120px", height: "40px", borderRadius: "5px" }}
                                onClick={handleModalSave}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </>
            )}
            <div className={"dataLoadpage " + showloader}></div>
            <div className={"dataLoadpageimg " + showloader}>
                <div className="loader-box">
                    <div className="loader-box">
                        <div className="rotate dashed colored"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}
